import React from 'react';
import { Modal, ModalHeader, ModalBody, ModalFooter, Button } from 'reactstrap';

const SchoolStatusChangeModal = ({ isOpen, onConfirm, onCancel, school }) => {
    return (
        <Modal
            isOpen={isOpen}
            toggle={onCancel}
            className="modal-centered contract-type-modal feedback-modal-style link-form"
        >
            <ModalHeader toggle={onCancel}>Wijzigen status school</ModalHeader>
            <ModalBody className="text-center mt-4 mb-4">
                <h5>
                    Wanneer de status van een school naar Inactief wordt gewijzigd, worden medewerkers
                    en melders van deze  <strong>{school}</strong> ontkoppeld.
                </h5>
            </ModalBody>
            <ModalFooter className="justify-content-center pt-3">
                <Button color="link" className="btn-color-style" onClick={onConfirm} >
                    Toepassen
                </Button>
                <Button color="link" className="btn-color-style" onClick={onCancel}>
                    Annuleren
                </Button>
            </ModalFooter>
        </Modal>
    );
};

export default SchoolStatusChangeModal;
